import { Button, Container, Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import FadeIn from 'react-fade-in/lib/FadeIn'
const Calculators = () => {

  return (
    <FadeIn transitionDuration="3000">
      <Typography variant="h3" style={{ color:'white' }}>Calculators</Typography>
      <Container className="button-grid-container">
        <div style={{ margin: '10%' }}>
          <Button
            component={Link}
            to="/Calculators/WasteHeat"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%',
              padding: '5%',
              borderRadius: '10px'
            }}
          >Waste Heat Calculator</Button>
          <div className="Pilot-areas"><Typography variant="subtitle1">Waste Heat Calculator can be used to input certain known parameters and calculate appromaximately buildings amount of waste heat.</Typography></div>
        </div>
        <div style={{ margin: '10%' }}>
          <Button
            component={Link}
            to="/Calculators/SolarEnergy"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%',
              padding: '5%',
              borderRadius: '10px'
            }}>Solar Energy Calculator</Button>
          <div className="Pilot-areas"><Typography variant="subtitle1">Solar Energy Calculator can be used to input certain known amounts and calculate annual yield of solar energy. This calculator uses data of Photovoltaic Geographical Information System (PVGIS). More information about tools and API can be found here: <a href="https://ec.europa.eu/jrc/en/pvgis">https://ec.europa.eu/jrc/en/pvgis</a></Typography></div>
        </div>
      </Container>
    </FadeIn>
  )
}

export default Calculators